import React from "react";

import { useTranslation, Trans } from "react-i18next";

import ba from '../../img/Home/ba.png'

import Button from '../Button'
import Fade from 'react-reveal/Fade';

import bglog from '../../img/Home/bglog.png'

function JoinBroker () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[280px] xl:pt-[190px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <Fade left><img src={bglog} className="hidden xl:block absolute top-[0] w-[150px]" alt="" /></Fade>
                <div className="rotate-180"><Fade left><img src={bglog} className="hidden xl:block absolute w-[150px] right-1/3 top-[-100px]" alt="" /></Fade></div>
                <div className="flex flex-col xl:flex-row justify-between xl:items-end items-center">
                    <div className="flex flex-col">
                        <p className="xl:max-w-[451px] open-sans font-[600] text-[#0C2780] text-[17px] xl:text-[19px] text-center">{t('home.20')}</p>
                        <p className="spantext text-[23px] xl:text-[45px] font-[700] text-[#0C2780] text-center"><Trans>{t('home.21')}</Trans></p>
                        <Button color={'#15318D'} text={'#FFFFFF'} className={'mt-[50px] hidden xl:block'}/>
                    </div>
                    <div className="mt-[35px] xl:mt-0 flex flex-col">
                        <img src={ba} alt="" />
                        <Button color={'#15318D'} text={'#FFFFFF'} className={'mt-[40px] xl:hidden block mx-auto'}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default JoinBroker;